import clsx from 'clsx';

// types
import type { AlbumCardGridLayoutType, AlbumCardMedia } from '@/lib/albums/types';

//libs
import { getCardGridStyles } from '@/lib/albums/getCardGridStyles';
import {
    getCardPostIconClasses,
    TwPostIcons,
    getTwMediaType
} from '@/lib/albums/albumCardIconType';
import { TWITTER } from '@/lib/socialProfile';

//components
import Icon from '@/components/base/Icon';

function MediaGridTwitter({
    medias,
    gridLayout
}: {
    medias: AlbumCardMedia[];
    gridLayout: AlbumCardGridLayoutType;
}) {
    const maxMedias = gridLayout === 'card' ? 4 : 3;
    const renderedMedias = medias.length > maxMedias ? medias.slice(0, maxMedias) : medias;
    return (
        <>
            {renderedMedias.map((media, index) => {
                const type = getTwMediaType(media.type as keyof typeof TwPostIcons, media.sub_type);
                return (
                    <span
                        data-testid={`grid-twitter-${type}`}
                        key={index}
                        className={getCardGridStyles({
                            index: index + 1,
                            size: renderedMedias?.length,
                            network: TWITTER,
                            gridLayout
                        })}>
                        <span
                            className={clsx(
                                'flex h-full w-full items-center justify-center',
                                getCardPostIconClasses(type),
                                { 'rounded-[1px]': gridLayout === 'table' }
                            )}>
                            <Icon
                                icon={TwPostIcons[type]}
                                data-testid={`icon-twitter-${TwPostIcons[type]}`}
                            />
                        </span>
                    </span>
                );
            })}
        </>
    );
}

export default MediaGridTwitter;
